import { cognitoConfig, oidcStorageKey } from './config.ts';

// fetch with the Cognito Bearer ID token attached (PRD-0006 D9). API Gateway's
// JWT authorizer gates /api/* on it and the backend re-verifies it in-app.
// With auth disabled (local dev / IAP deployment) this IS plain fetch.
//
// The token is read from oidc-client-ts's sessionStorage entry rather than
// React context so plain-module hooks can call this without prop-drilling.
export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const cfg = cognitoConfig();
  if (!cfg) return fetch(input, init);

  const token = idTokenFromStorage(oidcStorageKey(cfg));
  if (!token) return fetch(input, init);

  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
}

function idTokenFromStorage(key: string): string | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const user = JSON.parse(raw) as { id_token?: string };
    return user.id_token ?? null;
  } catch {
    return null;
  }
}
